import hotelService from 'services/hotel.service'

const state = {
    hotel: {},
    loading: false,
    isOpenForm: false,
    states: [],
    roomDescriptions: {},
}

const getters = {

}

const mutations = {
    setHotel(state, hotel = null) {
        state.hotel = hotel;
        state.states = hotel.states || [];
        state.roomDescriptions = hotel.room_descriptions || {};
    },
    setLoading(state, loading = false) {
        state.loading = loading;
    },
    setIsOpenForm(state, isOpen = false) {
        state.isOpenForm = isOpen;
    },
    toggleCancelRule(state, room) {
        const foundRoom = state.hotel.accomodations.find(r =>
            r.room_id == room.room_id &&
            r.meal_id == room.meal_id &&
            r.htplace_id == room.htplace_id
        );
        if (foundRoom) {
            foundRoom.showCancelRule = !foundRoom.showCancelRule;
        }
    },
}

const actions = {
    getHotel ({ commit }, params) {
        commit('setLoading', true)
        hotelService.getHotel(params).then(response => {
            commit('setHotel', response);
            commit('setLoading', false)
            window.scrollTo(0, 0);
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    setIsOpenForm({ commit }, isOpen = false){
        commit('setIsOpenForm', isOpen);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
